<template>
  <div class="category">
    <sidebar class="left" :list="sidebar" @seleced="seleced" :activeIndex="sidebarIndex"></sidebar>
    <!-- <goods :goodsInfo="goodsList" class="right"></goods> -->
    <cate :list="rightSidebarList" class="right"></cate>
  </div>
</template>
<script>
import { getCategory, goodsList } from '@/api/goods'

// import scroll from '@/mixins/scroll'


import { sidebar, cate } from "./components";


export default {
  components: {
    sidebar,
    cate
  },
  data () {
    return {
      sidebar: [],
      sidebarIndex: 0,
      goodsList: [],
      rightSidebarList: []
    }
  },
  // mixins: [scroll],
  methods: {
    // 选中侧边栏 id
    seleced (id) {
      this.sidebarIndex = id
      this.page = 1
      this.goodsList = []
      this.getCategory(2)
    },
    //获取商品列表
    async getList () {
      const result = await goodsList({
        page: 1,
        size: 25,
        first_cat_id: this.sidebarIndex
      })
      try {
        if (result.data.data.goodsList.data.length !== 0) {
          this.goodsList = result.data.data.goodsList.data
        } else {
          this.page = null
        }
      } catch (err) { }

    },

    // 获取一级分类
    async getCategory (grade = 1) {
      const result = await getCategory({
        grade: grade,
        parent_id: grade === 2 ? this.sidebarIndex : 0
      })
      const data = result.data.data
      if (data.status) {
        if (grade === 1) {
          this.page = 0
          this.sidebarIndex = data.cartList[0].cat_id
          this.sidebar = data.cartList
          // this.goodsList = []
          this.getCategory(2)
        }
        if (grade === 2) {
          this.rightSidebarList = data.cartList
        }
      }
    },
  },
  created () {
    this.getCategory()
    // this.getList()
  },
  activated () {
    // this.page = 1
    // this.goodsList = []
    // this.getList()
  }
}
</script>
<style lang="scss" scoped>
.category {
  margin: 0.1rem 0;
  .left {
    width: 30vw;
  }
  .right {
    width: 70vw;
    position: absolute;
    background: #fff;
    right: 0;
    height: 100%;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  }
}
</style>